import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IBrowsePeopleResponse } from './browse-people-response';
import { browsePeopleResponseSchema } from './browse-people-response';

export async function browsePeopleApi(): Promise<IValidatedResponse<IBrowsePeopleResponse>> {
  return getRequest<IBrowsePeopleResponse>({
    path: '/people/browse/v1',
    schema: browsePeopleResponseSchema,
  });
}
